import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  VACATION_PUBLIC_INFO,
  VACATION_REQUEST_CREATE,
  VACATION_REQUEST_DOWNLOAD,
  VACATION_REQUEST_LIST,
  VACATION_REQUEST_STATUS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const vacationList = createAsyncThunk(
  VACATION_REQUEST_LIST,
  async (params: PayloadCreatorParams<`${typeof API.VACATION_REQUEST}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.vacationList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const vacationCreate = createAsyncThunk(
  VACATION_REQUEST_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.VACATION_REQUEST}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.vacationCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const vacationDelete = createAsyncThunk(
  VACATION_REQUEST_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.VACATION_REQUEST}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.vacationDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const vacationDownload = createAsyncThunk(
  VACATION_REQUEST_DOWNLOAD,
  async (params: PayloadCreatorParams<`${typeof API.VACATION_REQUEST_DOWNLOAD}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.vacationDownload(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const vacationStatus = createAsyncThunk(
  VACATION_REQUEST_STATUS,
  async (params: PayloadCreatorParams<`${typeof API.VACATION_REQUEST_STATUS}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.vacationStatus(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const vacationPublicInfo = createAsyncThunk(
  VACATION_PUBLIC_INFO,
  async (params: PayloadCreatorParams<`${typeof API.VACATION_PUBLIC_INFO}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.vacationPublicInfo(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const vacationListClear = createAction(`${VACATION_REQUEST_LIST}/clear`)

export const vacationDownloadClear = createAction(`${VACATION_REQUEST_DOWNLOAD}/clear`)

export const vacationPublicInfoClear = createAction(`${VACATION_PUBLIC_INFO}/clear`)
